import styled from "styled-components";

const Wrapper = styled.a`
    display : block;
    box-shadow : 1px 1px 3px #ccc;
    border : solid thin #ccc;
    transition : 0.4s;
    &:hover{
        box-shadow : 5px 5px 3px #ccc;
        border : solid thin #2251cc;
    }
    width : 360px;
    .image{
        height : 200px;
        width : 100%;
    }

    h2{
        // font-size : 24px;
        font-weight : bold !important;
        margin : 20px;
        font-family : McKinsey Sans;
    }

    p{
        margin : 10px 20px;
        font-size : 18px;
        min-height : 57px;
        
        color : #6c6c6c;
    }

    .view-more{
        font-weight : bold;
        color : #000;
        margin : 20px;
        text-decoration : none;
        display : flex;
        align-items : center;
    }

    .bottom{
        margin : 30px 15px 20px 15px;
    }

    .bottom a{
        // width : 200px;
        margin : 10px 5px;
        font-size: 1rem;
    }

    .arrow-icon-right{
        width : 16px;
        margin : 0 0 0 10px;
    }
`

export default Wrapper